import isEqual from 'lodash/isEqual';
import { useRef } from 'react';

export function useMemoizeObject<T>(state: T) {
  const ref = useRef<T | undefined>();

  // @ts-ignore
  if (!isEqual(ref.current, state)) {
    ref.current = state;
  }

  return ref.current;
}
